import React, { useEffect } from 'react'
import MicroModal from "micromodal"

import { GetCourseData } from './CourseContentData'
import { useCourseReport } from '../context/CourseReportContext'
import CourseContentColumns from './CourseContentColumns'
import { useUserReport } from '../context/UserReportContext'
import TanstackContent from '../../Table/Tanstack/TanstackContent'
import { getExportHeaders } from '../types/tableHeaders'
import UserQuiz from '../../Table/Modal/UserQuiz'

/**
 * Course content includes:
 * Lessons, Topics, Quizzes, and Assignments activities of the user.
 */
const CourseContent = ({ type, from = 'course-report' }) => {
  const { courseDetails, selectedUser, userDatum } = from === 'course-report' ? useCourseReport() : useUserReport()
  const [rowSelection, setRowSelection] = React.useState({})
  const [globalFilter, setGlobalFilter] = React.useState('')
  const [data, setData] = React.useState(() => GetCourseData( courseDetails, selectedUser, type, userDatum ) )

  useEffect(() => {
    setData(() => GetCourseData( courseDetails, selectedUser, type, userDatum ))
  }, [ courseDetails, selectedUser, userDatum ])

  MicroModal.init()

  const columns = CourseContentColumns({type, from})

  const exportHeaders = getExportHeaders( type )
   
  const tanstackContentFrom = () => {
    switch( type ){
      case 'lessons':
        return 'Lessons Report'
      case 'topics':
        return 'Topics Report'
      case 'quizzes':
        return 'Quizzes Report'
      case 'assignments':
        return 'Assignments Report'
      default:
        return ''
    }
  }

  return (
    <TanstackContent
      data={data}
      columns={columns}
      rowSelection={rowSelection}
      setRowSelection={setRowSelection}
      sorting={null}
      setSorting={null}
      globalFilter={globalFilter}
      setGlobalFilter={setGlobalFilter}
      filterType={'course-content-filter'}
      children={null}
      exportHeaders={exportHeaders}
      from={tanstackContentFrom()}
      context={ from === 'course-report' ? 'Courses' : 'Users' }
      columnFilters={ null }
      setColumnFilters={ null }
    />
  )
}

export default CourseContent
